

export enum ChartTypes {
    HR_HRV = "HR_HRV",
    RMS_SNR = "RMS_SNR",
    SPIKE_COUNTS = "SPIKE_COUNTS",
    SPIKES = "SPIKES",
    DELTA_CONNECTIVITY = "DELTA_CONNECTIVITY",
    CONNECTIVITY_DISTRIBUTION = "CONNECTIVITY_DISTRIBUTION",
    CONNECTIVITY_MAP = "CONNECTIVITY_MAP",
    DELTA_HR = "DELTA_HR",
    BIOMARKER_DISTRIBUTION = "BIOMARKER_DISTRIBUTION",
    SPECTRUM = "SPECTRUM",
    IMPEDANCE = "IMPEDANCE",
    BIOMARKER_TIMESERIES = "BIOMARKER_TIMESERIES",
    RESEARCH = "RESEARCH"
}    // Add more chart types as needed

